import "../../../assets/stylesheets/StartApplication/MMLIS/MMLISContributionToast.scss";

function AddedMMLISContributionsToast(props) {
  const closeToast = () => {
    props.closeToast();
  };
  return (
    <>
      <div
        id="mmlis_contribution_added_alert"
        className={
          props.showToast === true
            ? "show col-md-5 alert-item"
            : "d-none col-md-5 alert-item"
        }
        style={{ float: "right" }}
      >
        <div className="mm-toast-container">
          <div
            className="toast"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="wrapper">
              <div className="toast-header">
                <strong>Contribution Details have been saved.</strong>
                <button
                  className="icon-close"
                  type="button"
                  data-dismiss="toast"
                  aria-label="Close"
                  onClick={closeToast}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddedMMLISContributionsToast;
